import React from 'react';
import PropTypes from 'prop-types';

const ClearAmountsButton = ({ name, onClear, className }) => {
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (window.confirm(`「${name}」の今月の金額を、全従業員分クリアします。よろしいですか？（保存するまで確定しません）`)) {
      onClear();
    }
  };

  return (
    <button
      aria-label={`「${name}」の金額を全員分クリア`}
      className={`btn btn-sm wageTimer clearAmounts ${className}`}
      data-bs-toggle="tooltip"
      onClick={handleClick}
      title="全員分クリア"
      type="button"
    >
      <i className="fa fa-eraser" />
    </button>
  );
};

ClearAmountsButton.defaultProps = {
  className: ''
};

ClearAmountsButton.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  onClear: PropTypes.func.isRequired
};

export default ClearAmountsButton;
